import styled from 'styled-components';

const Legend = styled.small`
   color: ${({ theme }) => theme.primaryGrey};
   font-size: small;
   align-content: center;

   span {
      color: ${({ theme }) => theme.primaryRed};
      font-size: 1.5em;
   }
`;

export default Legend;
